import Api from '@launchpad/logic/api/Api';
import { OverrideService } from '@launchpad/logic/services';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();

async function apiCall(
  url: string,
  method = 'GET',
  body: any = null,
  options: RequestInit = {}
) {
  const fullUrl = `${process.env.REACT_APP_VERSIONER_URL}${url}`;
  const axiosOptions: Record<string, unknown> = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Api.resolveToken()}`,
      'Application-Id': OverrideService.getConfig().packageName
    },
    body: body ? JSON.stringify(body) : null,
    ...options
  };
  const response = await fetch(fullUrl, axiosOptions);
  if (!response.ok) {
    const errorResponse = await response.json();
    const error: any = new Error(
      errorResponse?.message || 'An error occurred.'
    );
    error.code = response.status;
    error.info = errorResponse;
    throw error;
  }

  return response.json();
}

export default apiCall;
